import type { FieldCodec } from 'v5/core/entity-values/values.types';
import { customFieldColumns } from './customFieldColumns';
import { findCustomFieldRowForRead } from './customFieldRows';
import { validateField, validation } from './validation';

function isEmpty(value: number | null): boolean {
  return value === null;
}

/** PERCENTAGE custom field: a 0–100 number stored in `float_value` (legacy `PERCENTAGE.jsx`). */
export const percentageCodec: FieldCodec<'percentage'> = {
  decode(entity, spec, ctx) {
    const row = findCustomFieldRowForRead(entity, spec.definition.id, ctx);
    return row?.float_value ?? null;
  },
  encode(value) {
    return {
      type: 'custom',
      columns: customFieldColumns({ float_value: value })
    };
  },
  empty() {
    return null;
  },
  isEmpty,
  validate(value, spec) {
    return validateField(value, spec, isEmpty, value => {
      if (value === null) return validation.valid();
      if (!Number.isFinite(value)) {
        return validation.invalid({ code: 'not-a-number' });
      }
      if (value < 0 || value > 100) {
        return validation.invalid({ code: 'out-of-range', min: 0, max: 100 });
      }
      return validation.valid();
    });
  }
};
